import * as microsoftTeams from "@microsoft/teams-js";
import { useState, useEffect } from "react";

// Funzione per ottenere le informazioni dell'operatore loggato
const GetInfoOperatorLogged = async () => {

    try {
        // Inizializza l'app di Microsoft Teams e ottieni il contesto
        await microsoftTeams.app.initialize();
        const context = await microsoftTeams.app.getContext();

        // Ottieni la mail dell'utente loggato
        const userMailLogged = context.user.userPrincipalName;
        console.log("MAIL DELL'UTENTE LOGGATO: ", userMailLogged);

        // Chiamata API per ottenere le informazioni dell'operatore
        const response = await fetch("https://mapei.aion-asa.com/api/get_operator_info/", {
            method: "POST",
            headers: {
                "accept": "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                user_id: userMailLogged
            })
        });

        const data = await response.json();

        if (data.code === 200) {
            console.log("Operator info fetched:", data.operators);
            return data.operators;  // Ritorna l'array degli operatori
        } else {
            throw new Error("Errore nel recuperare le informazioni dell'operatore");
        }

    } catch (error) {
        console.error("ERROR GETTING OPERATOR INFO:", error);
        throw error; // Rilancia l'errore in modo che possa essere gestito all'esterno
    }
};

export default GetInfoOperatorLogged;
